import TableFile from "../TableFile";

export const TableItems = (
    filteredDataCount,
    file,
    filteredData,
    paginatedData,
    tabKey,
    setFilteredData,
) => {
  return [
    {
      label: `All (${filteredDataCount["all"]})`,
      key: "all",
      children: (
        <TableFile
          source={file}
          filteredData={filteredData}
          paginatedData={paginatedData}
          tabKey={tabKey}
          setFilteredData={setFilteredData}
        />
      ),
    },
    {
      label: `Open (${filteredDataCount[0]})`,
      key: 0,
      children: (
        <TableFile
          source={file}
          filteredData={filteredData}
          paginatedData={paginatedData}
          tabKey={tabKey}
          setFilteredData={setFilteredData}
        />
      ),
    },
    {
      label: `Closed (${filteredDataCount[1]})`,
      key: 1,
      children: (
        <TableFile
          source={file}
          filteredData={filteredData}
          paginatedData={paginatedData}
          tabKey={tabKey}
          setFilteredData={setFilteredData}
        />
      ),
    },
  ];
};